import Header from './components/Header'
import { useEffect } from 'react'
import Footer from './components/Footer'
import {Provider} from 'react-redux'
import store from './store'
import{ BrowserRouter  as Router, Routes, Route} from 'react-router-dom';
//import {makeStyles} from '@material-ui/core/Typography'
import { Adress } from './components/ProfileManagement/Adress';
import AddressUpdateScreen from './screens/AddressUpdateScreen';
import AuthenticationScreen from './screens/AuthenticationScreen';
import AntiqueDealerLicenseScreen from './screens/AntiqueDealerLicenseScreen';
import AppraisalStatusScreen from './screens/AppraisalStatusScreen';
import ArchiveFashionRentalScreen from './screens/ArchiveFashionRentalScreen';
import ArchiveCollectionScreen from './screens/ArchiveCollectionScreen';
import ArchiveGuideScreen from './screens/ArchiveGuideScreen';
import BrandBuybackScreen from './screens/BrandBuybackScreen';
import BrandListScreen from './screens/BrandScreen';
import BrandProductScreen from './screens/BrandProductScreen';
import BuyingConfirmScreen from './screens/BuyingConfirmScreen';
import CancellationReturnRefundPolicyScreen from './screens/CancellationReturnRefundPolicyScreen'
import CartScreen from './screens/CartScreen'
import CompensationScreen from './screens/CompensationScreen';
import KaitoriScreen from './screens/KaitoriScreen';
import KaitoriFormScreen from './screens/KaitoriFormScreen';
import KaitoriTakuhaiScreen from './screens/KaitoriTakuhaiScreen';
import CheckoutStep from './screens/CheckoutStep';
import CreditInfoScreen from './screens/CreditInfoScreen';
import CreditInfoUpdateScreen from './screens/CreditInfoUpdateScree ';
import CssBaseline from "@material-ui/core/CssBaseline";
import ContactScreen from './screens/ContactScreen';
import DeliveryHelpScreen from './screens/DeliveryHelpScreen';
import EmailUpdateScreen from './screens/EmailUpdateScreen';
import { Container } from '@material-ui/core';
import { Elements } from '@stripe/react-stripe-js';
import FavoriteProductScreen from './screens/FavoriteProductScreen';
import HelpScreen from './screens/HelpScreen';
import HomeScreen from './screens/HomeScreen'
import { InvoiceScreen } from './components/ProfileManagement/Invoice';
import IdeaScreen from './screens/IdeaScreen';
import InvitationCouponScreen from './screens/InvitationCouponScreen';
import LoginScreen from './screens/LoginScreen';
import NotificationScreen from './screens/NotificationScreen';
import NotificationListScreen from './screens/NotificationListScreen';
import RegisterScreen from './screens/RegisterScreen';
import ManagementScreen from './screens/ManagementScreen';
import OrderItemHistoryScreen from './screens/OrderItemHistoryScreen';
import PasswordReset from './components/ProfileManagement/ForgetPasswordComponent';
import PasswordResetEmail from './components/ProfileManagement/PasswordResetEmail';
import PasswordChangeScreen from './components/ProfileManagement/PasswordChange';
import PhoneNumberUpdateScreen from './screens/PhoneNumberUpdateScreen';
import PhoneNumberRegisterScreen from './screens/PhoneNumberRegisterScreen';
import PriceHelpScreen from './screens/PriceHelpScreen';
import PrivacyPolicyScreen from './screens/PrivacyPolicyScreen';
import ProductScreen from './screens/ProductScreen'
import ProfileScreen from './screens/ProfileScreen';
import ProvisionalRegistrationScreen from './screens/ProvisinalRegistrationScreen';
import PurChaseConfirmedScreen from './screens/PurchaseConfirmedScreen';
import ScrollToTop from './components/ScrollToTop';
import AnalyticsRouteTracker from './components/AnalyticsRouteTracker';
import SearchBarComponent from './components/SearchComponent';
import SearchProductScreen from './screens/SearchProductScreen'
import SecurityInfo from './screens/UserSecretInfo';
import SpecifiedCommercialScreen from './screens/SpecifiedCommercialScreen';
import StartGuideScreen from './screens/StartGuideScreen';
import TagProductScreen from './screens/TagProductScreen';
import TermOfService from './screens/TermOfServiceScreen';
import TodoScreen from './screens/TodoScreen';
import ReservationHelpScreen from './screens/ReservationHelpScreen';
import ReservationHistoryScreen from './screens/ReservationHistory';
import ReviewScreen from './screens/ReviewScreen';
import RegisterCompleteScreen from './screens/RegisterCompleteScreen';
//test
import ShippingForm from './screens/ShippingScreen';
import CreditListScreen from './screens/CreditListScreen';
import AddCreditScreen from './screens/CreditAddScreen';
import ReservationCalendar from './components/CalendarComponent';
import LineEstimate from './screens/LineEstimateScreen';
//import ChatgptImageForm from './components/chatgptComponent';
//strip component
import StripePlanScreen from './screens/StripePlanScreen';
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { loadStripe } from '@stripe/stripe-js';
//react-helmet-async
import {HelmetProvider} from 'react-helmet-async';

//publickeyは随時記述するのではなくバックエンド側から取ってくるようにする
const  App = () => {

  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY)
  //darkmode切り替えはheader内で行えるようにする
  //useSele
 
  const theme = createMuiTheme({
    palette: {
      background: {
        default: '#eeeeee',
      },
      primary: {
        'main': '#eeeeee',
        '50' :'#fafafa',
        '100': '#f5f5f5',
        '200': '#eeeeee',
        '300': '#e0e0e0',
        '400': '#bdbdbd',
        '500': '#9e9e9e',
        '600': '#757575',
        '700': '#616161',
        '800': '#424242',
        '900': '#212121',
      },
      secondary:{
        '50': '#fff8e1',
        '100': '#ffecb3',
        '200': '#ffe082',
        '300': '#ffd54f',
        '400': '#ffca28',
        '500': '#ffc107',
        '600': '#ffb300',
        '700': '#ffa000',
        '800': '#ff8f00',
        '900': '#ff6f00',
        'A100': '#ffe57f',
        'A200' : '#ffd740',
        'A400' : '#ffc400',
        'A700': '#ffab00',
      }},
    typography: {
        fontFamily: [
          'Helvetica Neue',
          'Arial',
          'Hiragino Kaku Gothic ProN',
          'Hiragino Sans',
          'sans-serif',
          '-apple-system',
          'BlinkMacSystemFont',
          '"Segoe UI"',
          'Roboto',
          '"Apple Color Emoji"',
          '"Segoe UI Emoji"',
          '"Segoe UI Symbol"',
        ].join(','),

        subtitle1:{
          fontSize:14,
        },
        subtitle2:{
          fontSize:12,
        },
        h1:{
          fontSize:24,
        },
        h2:{
          fontSize: 20,
        },
        h3:{
          fontSize:16,
        },
        h4:{
          fontSize:36
        },
        h5:{
          fontSize:20
        },
        h6:{
          fontSize:10
        }
      }
    ,

    'breakpoints': {
      'keys': [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
      ],
      'values': {
        'xs': 0,
        'sm': 431,
        'md': 769,
        'lg': 992,
        'xl': 1300,
      },
    },
  });

  theme.typography.subtitle1 = {
    [theme.breakpoints.down('xs')]:{
      fontSize: 12
    },
    [theme.breakpoints.up('xl')]:{
      fontSieze: 16
    }
  }
  theme.typography.subtitle2 = {
    [theme.breakpoints.down('xs')]:{
      fontSize: 9
    },
    [theme.breakpoints.up('xs')]:{
      fontSize: 10
    }
  }


  //appコンポーネント内では
  // 起動時にindex.htmlに残っている静的OGタグを除去（HelmetのOGのみ残す）
  useEffect(() => {
    try{
      const staticOg = document.querySelectorAll('meta[property^="og:"]:not([data-rh])')
      staticOg.forEach((el) => el.parentNode && el.parentNode.removeChild(el))
    }catch(e){ /* no-op */ }
  }, [])

  return (
    <HelmetProvider>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Elements stripe={stripePromise}>
      <Provider store={store}>
        <Router>
          <AnalyticsRouteTracker />
          <ScrollToTop />
            <Container maxWidth={'xl'} style={{padding:'initial'}}>
            <Header />
            <SearchBarComponent/>
            <main>
              <Routes>
                <Route path='/' element={<HomeScreen/>}/>
                <Route path='/address' element={<Adress/>} />
                <Route path='/address_update' element={<AddressUpdateScreen/>}/>
                <Route path='/antique_dealer_license' element={<AntiqueDealerLicenseScreen/>} />
                <Route path='/appraisal_status' element={<AppraisalStatusScreen/>}/>
                <Route path='/archive_collection' element={<ArchiveCollectionScreen/>}/>
                <Route path='/archive_collection/:slug' element={<ArchiveCollectionScreen/>}/>
                <Route path="/archive_guide" element={<ArchiveGuideScreen />} />
                <Route path="/archive_guide/:slug" element={<ArchiveGuideScreen />} />
                <Route path='/archive_fashion_rental' element={<ArchiveFashionRentalScreen/>}/>
                <Route path='/phone_number_authentication' element={<AuthenticationScreen/>}/>
                <Route path="/brand_buyback" element={<BrandBuybackScreen />} />
                <Route path="/brand_buyback/:slug" element={<BrandBuybackScreen />} />
                <Route path='/buying/:id' element={<BuyingConfirmScreen/>}/>
                <Route path='/brands' element={<BrandListScreen/>}/>
                <Route path='/brand/:id/' element={<BrandProductScreen/>}/>
                <Route path='/cancellation_return_refund_policy'  element={<CancellationReturnRefundPolicyScreen/>}/>
                <Route path='/cart/:id' element={<CartScreen/>} />
                <Route path='/checkout/:id' element={<CheckoutStep/>} />
                <Route path='/add_credit' element={<AddCreditScreen/>}/>
                <Route path='/credit' element={<CreditInfoScreen/>} />
                <Route path='/credit_list' element={<CreditListScreen/>} />
                <Route path='/credit_card/update' element={<CreditInfoUpdateScreen/>}/>
                <Route path='/contact' element={<ContactScreen/>}/>
                <Route path='/compensation' element={<CompensationScreen/>}/>
                <Route path='/email_update' element={<EmailUpdateScreen/>}/>
                <Route path='/kaitori' element={<KaitoriScreen/>}/>
                <Route path='/kaitori/takuhai' element={<KaitoriTakuhaiScreen/>}/>
                <Route path='/kaitori_form' element={<KaitoriFormScreen/>}/>
                <Route path='/favorite/product/list' element={<FavoriteProductScreen/>}/>
                <Route path='/help' element={<HelpScreen/>}/>
                <Route path='/help_guide' element={<StartGuideScreen/>}/>
                <Route path='/help_price' element={<PriceHelpScreen/>}/>
                <Route path='/help_delivery' element={<DeliveryHelpScreen/>}/>
                <Route path='/help_reservation' element={<ReservationHelpScreen/>}/>
                <Route path='/login' element={<LoginScreen/>} />
                <Route path='/idea' element={<IdeaScreen/>}/>
                <Route path='/invitation_coupon' element={<InvitationCouponScreen/>} />
                <Route path='/line_estimate' element={<LineEstimate/>}/>
                <Route path='/notification/:id' element={<NotificationScreen/>} />
                <Route path='/notifications' element={<NotificationListScreen/>} />
                <Route path='/management' element={<ManagementScreen/>} />
                <Route path='/order/history/:id' element={<OrderItemHistoryScreen/>} />
                <Route path='/passwrod_reset/email/confirm' element={<PasswordResetEmail/>}/>
                <Route path='/password_reset/password/confirm' element={<PasswordReset/>}/>
                <Route path='/password/change' element={<PasswordChangeScreen/>}/>
                <Route path='/phone_number_update' element={<PhoneNumberUpdateScreen/>}/>
                <Route path='/phone_number_register' element={<PhoneNumberRegisterScreen/>}/>
                <Route path='/privacy_policy' element={<PrivacyPolicyScreen/>}/>
                <Route path='/product/:id' element={<ProductScreen/>} />
                <Route path='/profile' element={<ProfileScreen/>} /> 
                <Route path='/provisianl_registration' element={<ProvisionalRegistrationScreen/>}/>
                <Route path='/purchase/item/:id/' element={<PurChaseConfirmedScreen/>}/>
                <Route path='/register' element={<RegisterScreen/>} />
                <Route path='/search/:id/' element={<SearchProductScreen/>} />
                <Route path='/subscription/plan' element={<StripePlanScreen/>} />
                <Route path='/subscription/info' element={<InvoiceScreen/>}/>
                <Route path='/specified_commercial' element={<SpecifiedCommercialScreen/>}/>
                <Route path='/reservation_history' element={<ReservationHistoryScreen/>}/>
                <Route path='/register_confirmed/:id' element={<RegisterCompleteScreen/>}/>
                <Route path='/review/:id' element={<ReviewScreen/>}/>
                <Route path='/security' element={<SecurityInfo/>} />
                <Route path='/shipping/:id' element={<ShippingForm/>} />
                <Route path='/tag/:id/' element={<TagProductScreen/>} />
                <Route path='/terms' element={<TermOfService/>}/>
                <Route path='/todo' element={<TodoScreen/>}/>
                <Route path='/calendar' element={<ReservationCalendar/>}/>
              </Routes>
              {/*<Route path="/styling" component={ChatgptImageForm}/>*/}
            </main>
            </Container>
            <Footer/>
        </Router>
      </Provider>
      </Elements>
    </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
